import React, { useState } from "react";
import { Tab } from "semantic-ui-react";
import { ListRequirements } from "../../../components/Admin/Requirements";
import "./Requirements.scss";
import { useLanguage } from "../../../contexts";

export function Requirements() {
  const [reload, setReload] = useState(false);
  const onReload = () => setReload((prev) => !prev);

  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const panes = [
    {
      menuItem: t("active_requirements"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListRequirements requirementsActive={true} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: t("inactive_requirements"),
      render: () => (
        <Tab.Pane attached={false}>
          <ListRequirements requirementsActive={false} reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <div className="requirements-page" style={{ padding: "0 0 1.5rem" }}>
      <div className="requirements-page-header-wrapper">
        <div className="requirements-page-header">
          <span className="requirements-page-title">{t("requirements")}</span>
        </div>
      </div>
      <Tab menu={{ secondary: true, pointing: true }} panes={panes} />
    </div>
  );
}
